var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"border-y-1 border-solid border-midnight-gray-50 background-midnight-gray-white omnibus",class:{
    'border-radius-16 border-x-1 padding-a-6': !_vm.fullWidth,
    'border-x-0 padding-a-4': _vm.fullWidth,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }